import i18next from 'i18next';
import PropTypes from 'prop-types';
import React from 'react';

import Text, { ENUM_COLORS, ENUM_FONTS } from '@commons/Text';

import { CategoryChevron, CategoryRow } from './styledComponents';

/**
 * Collapsible header of a category group in the order product tables: the chevron carries the
 * collapsed state, and the row takes the green Figma hover state (node 843-21200) on hover.
 */
const OrderCategoryRow = (props) => {
  const { category, productCount, isCollapsed, onToggle } = props;

  const countLabel = i18next.t(
    productCount > 1
      ? 'EXTERNAL_ORDERS.FORM.CATEGORY_PRODUCT_COUNT_PLURAL'
      : 'EXTERNAL_ORDERS.FORM.CATEGORY_PRODUCT_COUNT',
    { productCount },
  );

  return (
    <CategoryRow onClick={onToggle}>
      <CategoryChevron
        className={'category-chevron-default'}
        src={
          isCollapsed
            ? '/images/inpulse/carret-right-black.svg'
            : '/images/inpulse/carret-bottom-black.svg'
        }
      />
      {/* Green variant shown on row hover, cut on the same geometry as the black one. */}
      <CategoryChevron
        className={'category-chevron-hover'}
        src={
          isCollapsed
            ? '/images/inpulse/carret-right-green.svg'
            : '/images/inpulse/carret-bottom-green.svg'
        }
      />
      <Text color={ENUM_COLORS.DARKEST} font={ENUM_FONTS.TEXT_BIG_HEIGHT_16}>
        {`${category} (${countLabel})`}
      </Text>
    </CategoryRow>
  );
};

OrderCategoryRow.propTypes = {
  category: PropTypes.string.isRequired,
  productCount: PropTypes.number.isRequired,
  isCollapsed: PropTypes.bool.isRequired,
  onToggle: PropTypes.func.isRequired,
};

export default OrderCategoryRow;
